
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { OA_STATUS } from "@/constants/services";

const APPROVED_FINAL_DECISION = "Approved";
const REJECTED_FINAL_DECISION = "Rejected";

const FINAL_DECISIONS = {
  approved: APPROVED_FINAL_DECISION,
  rejected: REJECTED_FINAL_DECISION,
};

@Component({
  components: {
    RejectedByHO: () => import("./Highlight/RejectedByHO.vue"),
    ApprovedByHO: () => import("./Highlight/ApprovedByHO.vue"),
    Hello: () => import("./Highlight/Hello.vue"),
  },
})
export default class PaidServicesHighlight extends Vue {
  get caseId(): number {
    return Number(this.$route.params.id);
  }

  init = false;

  statuses = OA_STATUS;

  finalDecision = "";
  finalDecisions = FINAL_DECISIONS;

  counter = 0;

  async getCase() {
    try {
      const { data } = await this.axios.get(API_ROUTES.CASE_ID(this.caseId));

      if (!data) return;

      this.finalDecision = data.final_decision;
    } finally {
      this.init = true;
    }
  }

  // BUG: In some reason "mounted" hook, init after leave current route;
  mounted() {
    // "Init" help us to control duplicating of requests;
    if (!this.init) this.getCase();
  }

  activated() {
    // NOTE: This approach helps us to refresh "data" without reloading component;
    if (!this.init) this.getCase();
  }
}
